import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import api from '../config/axios';

interface ShopInfo {
  name: string;
  logoUrl: string | null;
  taxRate: number;
}

interface ShopContextValue extends ShopInfo {
  loading: boolean;
  refresh: () => Promise<void>;
}

const ShopContext = createContext<ShopContextValue>({
  name: '',
  logoUrl: null,
  taxRate: 0,
  loading: true,
  refresh: async () => {},
});

export const useShop = () => useContext(ShopContext);

// Tải thông tin shop (tên, logo, thuế) theo tên miền, một lần khi mở app.
export const ShopProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [info, setInfo] = useState<ShopInfo>({ name: '', logoUrl: null, taxRate: 0 });
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const res = await api.get('/api/shop/current');
      if (res.data?.data) {
        setInfo({
          name: res.data.data.name || '',
          logoUrl: res.data.data.logoUrl || null,
          taxRate: res.data.data.taxRate || 0,
        });
      }
    } catch {
      /* giữ mặc định nếu không tải được */
    }
  }, []);

  useEffect(() => {
    let alive = true;
    refresh().finally(() => {
      if (alive) setLoading(false);
    });
    return () => {
      alive = false;
    };
  }, [refresh]);

  useEffect(() => {
    if (info.name) document.title = info.name;
  }, [info.name]);

  return <ShopContext.Provider value={{ ...info, loading, refresh }}>{children}</ShopContext.Provider>;
};
